if (!customElements.get('grid-item-slider')) {
  class GridItemSlider extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
      this.mediaQuery = window.matchMedia('(max-width: 880px)');
      this.initAttempts = 0;
      this.hintShown = false;
      this.hintTimeout = null;
    }

    connectedCallback() {
      this.init();
    }

    init() {
      if (typeof Swiper !== 'undefined') {
        this.handleMediaChange();
        this.mediaQuery.addEventListener('change', () => this.handleMediaChange());
      } else if (this.initAttempts < 50) {
        // Swiper not loaded yet, wait for it (max 5 seconds)
        this.initAttempts++;
        setTimeout(() => this.init(), 100);
      }
    }

    handleMediaChange() {
      if (this.mediaQuery.matches) {
        this.initSwiper();
      } else {
        this.destroySwiper();
      }
    }

    initSwiper() {
      if (this.swiper) return;

      const swiperEl = this.querySelector('.swiper');
      if (!swiperEl) return;

      this.swiper = new Swiper(swiperEl, {
        slidesPerView: 1,
        loop: true,
        pagination: {
          el: swiperEl.querySelector('.swiper-pagination'),
          clickable: true,
        },
      });

      // Prevent link click when swiping
      let slideChanged = false;
      
      this.swiper.on('slideChange', () => {
        slideChanged = true;
      });

      this.swiper.on('touchStart', () => {
        slideChanged = false;
        // Cancel hint animation if user starts interacting
        if (this.hintTimeout) {
          clearTimeout(this.hintTimeout);
          this.hintTimeout = null;
        }
      });

      this.swiper.on('touchEnd', () => {
        if (slideChanged) {
          const link = this.closest('a');
          if (link) {
            link.style.pointerEvents = 'none';
            setTimeout(() => link.style.pointerEvents = '', 100);
          }
        }
      });

      // Show swipe hint after 3 seconds (only on first slider and if multiple slides exist)
      if (!this.hintShown && this.swiper.slides.length > 1 && this.isFirstSlider()) {
        this.hintTimeout = setTimeout(() => {
          this.showSwipeHint();
        }, 2000);
      }
    }

    isFirstSlider() {
      const allSliders = document.querySelectorAll('grid-item-slider');
      return allSliders[0] === this;
    }

    showSwipeHint() {
      if (!this.swiper || this.hintShown) return;
      
      this.hintShown = true;
      const wrapper = this.swiper.wrapperEl;
      
      // Disable transitions temporarily for smoother control
      this.swiper.setTransition(500);
      
      // Slide to 50% of the next slide
      const currentTranslate = this.swiper.getTranslate();
      const slideWidth = this.swiper.slides[0].offsetWidth;
      const hintTranslate = currentTranslate - (slideWidth * 0.5);
      
      this.swiper.setTranslate(hintTranslate);
      
      // Slide back after 700ms
      setTimeout(() => {
        if (this.swiper) {
          this.swiper.setTransition(600);
          this.swiper.setTranslate(currentTranslate);
          
          // Re-enable normal transitions
          setTimeout(() => {
            if (this.swiper) {
              this.swiper.setTransition(300);
            }
          }, 600);
        }
      }, 700);
    }

    destroySwiper() {
      if (this.hintTimeout) {
        clearTimeout(this.hintTimeout);
        this.hintTimeout = null;
      }
      
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }

    disconnectedCallback() {
      this.destroySwiper();
      this.mediaQuery.removeEventListener('change', () => this.handleMediaChange());
    }
  }

  customElements.define('grid-item-slider', GridItemSlider);
}
